import { useCallback, useEffect, useRef, useState } from 'react';

import { CarouselSwiper } from './carouselSwiper/carouselSwiper';
import type { CarouselBanner } from './types/carousel';

interface CarouselProps {
  items: CarouselBanner[];
  stockPhoto?: boolean;
  storeName?: string;
  variant?: 'brand' | 'product';
  withLightBox?: boolean;
}

const AUTO_SLIDE_INTERVAL = 7000;

export const Carousel = ({ items = [], storeName, variant }: CarouselProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const startAutoSlide = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, AUTO_SLIDE_INTERVAL);
  }, [items.length]);

  const updateIndex = (newIndex: number) => {
    setActiveIndex(newIndex);
    startAutoSlide();
  };

  useEffect(() => {
    startAutoSlide();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [startAutoSlide]);

  return (
    <CarouselSwiper
      items={items}
      activeIndex={activeIndex}
      updateIndex={updateIndex}
      variant={variant}
      storeName={storeName}
    />
  );
};
